import {
  formatDisplayDateTime,
  formatDisplayTime,
  formatIndianDateTime,
  formatIndianTime,
  formatUtcDateTime,
  formatUtcTime,
} from "../lib/operatorFormatters";

export const EQUITY_TIMEFRAMES = [
  { id: "1H", label: "1H", windowMs: 60 * 60 * 1000 },
  { id: "4H", label: "4H", windowMs: 4 * 60 * 60 * 1000 },
  { id: "12H", label: "12H", windowMs: 12 * 60 * 60 * 1000 },
  { id: "ALL", label: "All", windowMs: null },
];

export function buildDurableEquityPoints(historyData, timeframe, now = Date.now()) {
  const points = Array.isArray(historyData)
    ? historyData
      .map((snapshot) => {
        const timestamp = Date.parse(snapshot.ts);
        const equity = Number(snapshot.equity);
        if (!Number.isFinite(timestamp) || !Number.isFinite(equity)) return null;
        return {
          ts: snapshot.ts,
          time: formatDisplayTime(snapshot.ts),
          fullTime: formatDisplayDateTime(snapshot.ts),
          istTime: formatIndianTime(snapshot.ts),
          istDateTime: formatIndianDateTime(snapshot.ts),
          utcTime: formatUtcTime(snapshot.ts),
          utcDateTime: formatUtcDateTime(snapshot.ts),
          equity,
        };
      })
      .filter(Boolean)
    : [];
  const selectedTimeframe = EQUITY_TIMEFRAMES.find((item) => item.id === timeframe)
    || EQUITY_TIMEFRAMES[EQUITY_TIMEFRAMES.length - 1];
  if (!selectedTimeframe.windowMs) return points;
  const cutoff = now - selectedTimeframe.windowMs;
  return points.filter((point) => Date.parse(point.ts) >= cutoff);
}
